export const AUTH_CONSTANTS = {
    USER_CACHE_KEY: 'cachedUser',

    /** Query parameter of a coach's referral link, and where its code is kept until sign-up. */
    REFERRAL_QUERY_PARAM: 'ref',
    REFERRAL_CODE_KEY: 'referralCode',
};
